export class Allergen {
  /**
   *
   * @param {number} id
   * @param {string|null} description
   * @param {string} name
   * @param {string} path
   */
  constructor(id, description, name, translation_id, merchant_id, image) {
    this.id = id;
    this.description = description;
    this.name = name;
    this.translation_id = translation_id;
    this.merchant_id = merchant_id;
    this.image = image;
  }

  getImagePath() {
    if (!this.merchant_id) {
      return "https://mynober-api-public.s3.eu-central-1.amazonaws.com/allergens/" + this.id + ".png";
    } else if (this.image) {
      return "https://mynober-api-public.s3.eu-central-1.amazonaws.com/" + this.image;
    }
  }
}

export const CreateAllergen = (json) => {
  return new Allergen(json.id, json.description, json.name, json.translation_id, json.merchant_id, json.image);
};
